import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "aci-theme";

export default function ThemeToggle() {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));

  useEffect(() => {
    document.documentElement.classList.toggle("light", light);
    localStorage.setItem(KEY, light ? "light" : "dark");
  }, [light]);

  return (
    <button
      type="button"
      onClick={() => setLight((v) => !v)}
      data-testid="theme-toggle"
      aria-label={light ? "Switch to dark theme" : "Switch to light theme"}
      aria-pressed={light}
      className="group relative flex h-9 w-[4.25rem] items-center rounded-full border border-line/15 bg-line/5 px-1 transition-colors duration-300 hover:border-brand/50"
    >
      <span
        aria-hidden="true"
        className={`flex h-7 w-7 items-center justify-center rounded-full bg-brand text-base shadow-[0_0_14px_rgb(var(--c-brand)/0.5)] transition-transform duration-300 ease-out ${
          light ? "translate-x-[1.9rem]" : "translate-x-0"
        }`}
      >
        {light ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-between px-2.5 font-mono text-[9px] uppercase tracking-widest text-dim">
        <span className={light ? "opacity-100" : "opacity-0"}>Dk</span>
        <span className={light ? "opacity-0" : "opacity-100"}>Lt</span>
      </span>
    </button>
  );
}
